import { CommentTypeEnum } from '../../constants';
import ResponseModel from '../responses/ResponseModel';

const defaultTextEditorValue =
  '{"blocks":[{"key":"75mui","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export default class CommentModel {
  id: string;
  referenceId: number;
  key: number;
  index: number;
  type: string;
  topic: any;
  topicId: string;
  customTopic: string;
  addressTo: any;
  addressToId: string;
  description: string;
  recommendation: string;
  touched: false;
  audioId: string;
  audioName: string;
  transcriptId: string;
  transcriptName: string;
  attachments: any[];
  response: ResponseModel | null;
  responseDescription: string;

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.referenceId = data.referenceId;
    this.key = Math.random() * Date.now();
    this.index = data.order || -1;
    this.type = data.type || CommentTypeEnum.Default;
    this.topic = data.topic;
    this.topicId = data.topicId || '';
    this.customTopic = data.customTopic || '';
    this.addressTo = data.addressTo;
    this.addressToId = data.addressToId || null;
    this.description = data.description || defaultTextEditorValue;
    this.recommendation = data.recommendation || defaultTextEditorValue;
    this.touched = typeof data.touched === 'boolean' ? data.touched : false;
    this.audioId = data.audio?.id || data.audioId || null;
    this.audioName = data.audio?.filename || data.audioName || null;
    this.transcriptId = data?.transcript?.id || data.transcriptId || null;
    this.transcriptName = data?.transcript?.filename || data.transcriptName || null;
    this.attachments = data.attachments || [];
    this.response = new ResponseModel(data.response || { commentId: data.id });
    this.responseDescription = data?.response?.description || defaultTextEditorValue;
  }
}
